import { createContext, useState } from "react";

export const DocumentContext = createContext();

const DocumentContextProvider = (props) => {
    // var docsTest = [
    //     {id: 1, date: '11/02/2020', type: 'Invoice'},
    //     {id: 2, date: '14/02/2020', type: 'Letter'},
    //     {id: 3, date: '19/02/2020', type: 'Letter'},
    //     {id: 4, date: '11/03/2020', type: 'Follow up'},
    //     {id: 5, date: '11/03/2020', type: 'Invitation'},
    //     {id: 6, date: '11/03/2020', type: 'Letter'},
    //     {id: 7, date: '11/04/2020', type: 'Invoice'},
    //     {id: 8, date: '05/05/2020', type: 'Invoice'},
    //     {id: 9, date: '10/05/2020', type: 'Letter'},
    //     {id: 10, date: '10/05/2020', type: 'Invitation'},
    //     {id: 2, date: '14/02/2020', type: 'Letter'},
    //     {id: 3, date: '19/02/2020', type: 'Letter'},
    //     {id: 4, date: '11/03/2020', type: 'Follow up'},
    //     {id: 5, date: '11/03/2020', type: 'Invitation'},
    //     {id: 6, date: '11/03/2020', type: 'Letter'},
    //     {id: 7, date: '11/04/2020', type: 'Invoice'},
    //     {id: 8, date: '05/05/2020', type: 'Invoice'},
    //     {id: 9, date: '10/05/2020', type: 'Letter'},
    //     {id: 10, date: '10/05/2020', type: 'Invitation'},
    // ];

    const [docs, setDocs] = useState([]);

    // const getDocs = () => {

    //     return new Promise(async function (resolve, reject) {
    //         var token = localStorage.getItem("token");
    //         var getRequest = {
    //             fieldData: {
    //                 FirstName: "Getting doc details"
    //             },
    //             script: "GetUserCorrespondanceDetails",
    //             "script.param": JSON.stringify({ token })
    //         };

    //         await postRequest(getRequest)
    //             .then(function (result) {
    //                 if (result.code === 200) {
    //                     var downloaded = result.data;

    //                     downloaded.map(doc => {
    //                         var [day, month, year] = doc.date.split('/');
    //                         doc["dateCon"] = new Date(year, month, day).getTime() / 1000;
    //                     });
    //                     setDocs(...[downloaded]);
    //                     resolve();
    //                 }

    //                 if (result.code === 401) {
    //                     history.replace('/choosepassword');
    //                     reject("Force password change");
    //                 }
    //             })
    //             .catch(function (error) {
    //                 history.push('/portal');
    //                 console.log(error);
    //             });
    //     })

    // };

    const setDocsDownloaded = (docs) => {
        setDocs([...docs]);
    };

    const getSearchedDocs = (search) => {
        return docs.filter(o =>
            Object.keys(o).some(k => o[k].toString().toLowerCase().includes(search.toLowerCase())));
    };

    return (
        <DocumentContext.Provider value={{ docs, getSearchedDocs, setDocsDownloaded }}>
            {props.children}
        </DocumentContext.Provider>
    );
}

export default DocumentContextProvider;